import {
    BOARD_TYPE,
    CONTEXTUAL_NUDGE_TYPE,
    IBoardConfig,
    // IColoredBoxes,
    // IContextualNudgeItemInStore,
    // IGameTimerNudgeStore,
    // IKilledKukari,
    // IKukariPositionData,
    // IMovingKukari,
    // IPlayerUIData, IQuickGuideItem, IQuickGuideRow,
    // IScoreFlyAnimationConfigForPlayer,
    // ISmoke,
    // ITtoScreenData,
    PLAYER_NUMBER,
    // TTO_COUNT,
    // UserProfile
  } from '../../../pages/GamePlay/types'
  import _forEach from 'lodash/forEach'
  import _reduce from 'lodash/reduce'
//   import { BOARD_CONFIG } from 'screens/gameplay/constants'
  import _get from 'lodash/get'
  import _isNil from 'lodash/isNil'
//   import translations from 'utils/helpers/localization'
  import _has from 'lodash/has'
//   import { getPlayerNumberForSeatIndex } from 'screens/gameplay/utils'
  import _includes from 'lodash/includes'
  import _isEmpty from 'lodash/isEmpty'
//   import { StateType } from 'store/selectors/interface'
  import _range from 'lodash/range'
  import _find from 'lodash/find'
import { StateType } from '../../../store/selectors/interface'
  
//   export function getPlayerToScoreMap(state: StateType) {
//     const playersInfo = getPlayersInfo(state)
//     const boardType = getBoardType(state)
  
//     const playerToScoreMap: { [playerNumber in PLAYER_NUMBER]?: number } = {}
  
//     if (!_isNil(boardType) && !_isNil(playersInfo)) {
//       _forEach(playersInfo, pInfo => {
//         if (_isEmpty(pInfo)) {
//           return
//         }
//         const playerNumber = getPlayerNumberForSeatIndex(getTotalPlayers(state), getMySeatIndex(state), pInfo?.si)
//         playerToScoreMap[playerNumber] = _reduce(
//           pInfo?.dvp,
//           (s: number, v: number) =>
//             (s += v === BOARD_CONFIG[boardType]?.PATH_FINAL_INDEX ? (BOARD_CONFIG[boardType]?.HOME_KUKARI_SCORE as number) : v),
//           0
//         )
//       })
//     }
  
//     return playerToScoreMap
//   }
  
//   export function getPlayerScore(playerNumber: PLAYER_NUMBER, state: StateType) {
//     return _get(getPlayerToScoreMap(state), playerNumber, 0)
//   }
  
  // export function getIsMySeatIndex(playerNumber: PLAYER_NUMBER, state: StateType): boolean {
  //   return _get(state, `ludoboard.tableInfo.${playerNumber}`) === getMySeatIndex(state)
  // }
  
//   export function getTurnPlayer(state: StateType): PLAYER_NUMBER | null {
//     const turnSi = getTurnSi(state)
//     if (!_isNil(turnSi)) {
//       return getPlayerNumberForSeatIndex(getTotalPlayers(state), getMySeatIndex(state), getTurnSi(state))
//     }
//     return null
//   }
  
  export function getTurnSi(state: StateType): number | null | undefined {
    return _get(state, 'ludoboard.tableInfo.turnSi')
  }
  
  export function getIsTtsix(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.IsTtsix', false)
  }
  
  export function getPlayersInfo(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.pi', [])
  }
  
  export function getPlayerRank(playerNumber: PLAYER_NUMBER, state: StateType): number | null {
    const si = _get(state, `ludoboard.tableInfo.${playerNumber}`) as unknown as number
    return _get(state, `ludoboard.tableInfo.rankData[${si}]`, null)
  }
  
  export function getRankData(state: StateType): Array<number> | null {
    return _get(state, 'ludoboard.tableinfo.rankData', null)
  }
  
  export function getMySeatIndex(state: StateType): number | null | undefined {
    return _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.ONE}`, null)
  }
  
  export function getGameStartCountdown(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.gameStartCountdown')
  }
  
  export function getStartGameIcon(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.startGameIcon', false)
  }
  
  export function getShowGameTimeNudge(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.showGameTimeNudge', false)
  }
  
  export function getShowStartGameNudge(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.showGameStartNudge', false)
  }
  
  export function getShowEndGameNudge(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.showGameEndNudge', false)
  }
  
  export function getShowExtraMoveNudge(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.showExtraMoveNudge', false)
  }
  
//   export function getTripleSixAnimation(state: StateType): boolean {
//     return _get(state, 'ludoboard.tableInfo.tripleSixAnimation',)
//   }
  
export function getTableId(state: StateType): string {
    return _get(state, 'ludoboard.tableInfo._id', ''); // Default to an empty string
  }
  
  // export function getTotalTurnTime(state: StateType) {
  //   return _get(state, 'ludoboard.tableInfo.stt', 15)
  // }
  
  export function getBoardType(state: StateType): BOARD_TYPE {
    return _get(state, 'ludoboard.tableInfo.boardType', BOARD_TYPE.DEFAULT_BOARD)
  }
  
  export function getPrizePot(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.prizePot', null)
  }
  
  export function getPayoutDistribution(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.payoutDistribution', {})
  }
  
  export function getPoolDistribution(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.poolDistribution', [])
  }
  
  export function getEntryFee(state: StateType): number | null {
    return _get(state, 'ludoboard.tableInfo.entryFee', null)
  }
  
  export function getGameTimer(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.gameTimer')
  }
  
  export function getTableStartTime(state: StateType): number | null {
    return _get(state, 'ludoboard.tableInfo.tableStartTime', 0)
  }
  
  export function getGameClockUrl(state: StateType): string | null {
    return _get(state, 'ludoboard.tableInfo.gameClockUrl', null)
  }
  
  export function getShowWrongTurnAlert(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.showWrongTurnAlert', false)
  }
  
  export function getTotalPlayers(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.totalPlayers', 0)
  }
  
  export function getMovingKukari(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.movingKukari', null)
  }
  
  export function getBounceAnimation(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.bounceAnimation', false)
  }
  
  // export function getDiceValue(state: StateType) {
  //   return _get(state, 'ludoboard.tableInfo.dv', null)
  // }
  
  // export function getResetTimer(state: StateType) {
  //   return _get(state, 'ludoboard.tableInfo.resetTimer', 0)
  // }
  
  export function getInternetConnectivityStatus(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.internetConnectivity', null)
  }
  
  // export function getTokenPosition(si: number | null, playerNumber: number, tokenIndex: number, state: StateType): number | null {
  //   const currSi = !_isNil(si) ? si : _get(state, `ludoboard.tableInfo.${playerNumber}`)
  
  //   return _get(state, `ludoboard.tableInfo.pi.${currSi}.dvp.${tokenIndex}`, null)
  // }
  
//   export function getSmoke(state: StateType): ISmoke | null {
//     return _get(state, 'ludoboard.tableInfo.smoke', null)
//   }
  
  export function getIsWaitingForPlayers(state: StateType) {
    const pi = getPlayersInfo(state)
    const totalPlayers = getTotalPlayers(state)
    const leftPlayers = getLeftPlayers(state)
  
    return (
      _isEmpty(leftPlayers) &&
      (_isEmpty(pi) || pi.length < totalPlayers || _reduce(pi, (res, pInfo) => res || _isEmpty(pInfo), false))
    )
  }
  
//   export function getMovableKukaris(state: StateType) {
//     const turnSi = getTurnSi(state) as number
//     const startBounceAnimation = getBounceAnimation(state)
//     const pInfo = getPlayersInfo(state)?.[turnSi]
//     const diceValue = getDiceValue(state) as number
//     const mySeatIndex = getMySeatIndex(state)
//     const boardConfig = BOARD_CONFIG[getBoardType(state)]
  
//     const movableKukaris: number[] = []
  
//     if (startBounceAnimation && mySeatIndex === turnSi) {
//       _forEach(pInfo?.dvp, (v: number, i: number) => {
//         if (v + diceValue + 1 <= boardConfig?.PATH_FINAL_INDEX) {
//           movableKukaris.push(i)
//         }
//       })
//     }
  
//     return movableKukaris
//   }
  
  // export function getCoinAnimation(state: StateType): boolean {
  //   return _get(state, 'ludoboard.tableInfo.coinAnimation', false)
  // }
  
  export function getHomeAnimationConfig(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.homeAnimationConfig', null)
  }
  
  export function getHomeAnimationConfigNx(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.homeAnimationConfigNx', null)
  }
  
//   export function formMoverString(si: number) {
//     switch (si) {
//       case 0:
//         return translations.firstMover
//       case 1:
//         return translations.secondMover
//       case 2:
//         return translations.thirdMover
//       case 3:
//         return translations.fourthMover
//       default:
//         return ''
//     }
//   }
  
//   export function formMoverStringNew(si: number) {
//     switch (si) {
//       case 0:
//         return translations.firstMoverNew
//       case 1:
//         return translations.secondMoverNew
//       case 2:
//         return translations.thirdMoverNew
//       case 3:
//         return translations.fourthMoverNew
//       default:
//         return ''
//     }
//   }
  
//   export function getMoverString(playerNumber: PLAYER_NUMBER, state: StateType): string {
//     const si = _get(state, `ludoboard.tableInfo.${playerNumber}`) as unknown as number
  
//     const boardType = getBoardType(state)
  
//     return boardType === BOARD_TYPE.TRIO_BOARD ? formMoverString(si) : formMoverStringNew(si)
//   }
  
  export function getIsPlayerLeft(playerNumber: PLAYER_NUMBER, state: StateType): boolean {
    const si = _get(state, `ludoboard.tableInfo.${playerNumber}`) as unknown as number
    const pInfo = _get(state, `ludoboard.tableInfo.pi.${si}`, null)
    const leftPlayers = getLeftPlayers(state)
  
    return _isEmpty(pInfo) && leftPlayers.length > 0
  }
  
  // export function getTimeLeft(state: StateType) {
  //   return _get(state, 'ludoboard.tableInfo.timeLeft')
  // }
  
  export function getTimeBankTimeLeft(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.timeBankTimeLeft', 0)
  }
  
  export function getIsTimeBankVisible(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.isTimeBankVisible', false)
  }
  
  export function getNxMovesLeft(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.movesLeft', 0)
  }
  
  export function getNxScore(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.score', 0)
  }
  
  // export function getStartDice(state: StateType) {
  //   return _get(state, 'ludoboard.tableInfo.startDice', null)
  // }
  export function getQuickGuide(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.quickGuide', null)
  }
  
//   export function getPlayerUIData(playerNumber: PLAYER_NUMBER, state: StateType): IPlayerUIData {
//     const turnSi = getTurnSi(state)
//     const si = _get(state, `ludoboard.tableInfo.${playerNumber}`) as unknown as number
//     const leftPlayers = getLeftPlayers(state)
//     const pInfo = _get(state, `ludoboard.tableInfo.pi.${si}`, null)
//     const mySeatIndex = getMySeatIndex(state)
//     const showSkipBox = _get(state, 'ludoboard.tableInfo.showSkipBox', false)
//     const skipSi = _get(state, 'ludoboard.tableInfo.skipSi')
//     const boardType = getBoardType(state)
  
//     return {
//       startDice: turnSi === si ? getStartDice(state) : null,
//       dv: getDiceValue(state),
//       timeLeft: getTimeLeft(state),
//       isTurn: turnSi === si,
//       isLeft: _isEmpty(pInfo) && leftPlayers.length > 0,
//       pp: _get(pInfo, 'ui.pp', null),
//       id: _get(pInfo, 'ui._id', null),
//       pText: _get(pInfo, 'ui.un', translations.invite),
//       TCount: _get(pInfo, 'TCount', TTO_COUNT.ZERO),
//       isMySeatIndex: mySeatIndex === si,
//       totalTurnTime: getTotalTurnTime(state),
//       zuid: _get(pInfo, 'ui.zupeeUserId'),
//       playerUIConfig: BOARD_CONFIG[boardType]?.PLAYER_UI_CONFIG[playerNumber],
//       moveString: formMoverString(si),
//       gameTimer: getGameTimer(state),
//       resetTimer: getResetTimer(state),
//       showSkipBox: showSkipBox && skipSi === si,
//       si,
//       coinAnimation: getCoinAnimation(state) && !getLocationTooltipText(state),
//       showTurnTimer: _get(state, 'ludoboard.tableInfo.showTurnTimer')
//     }
//   }
  
// export function getIsKukariScoreVisible(state: StateType): boolean {
//   return _get(state, 'ludoboard.tableInfo.isKukariScoreVisible', false)
// }
  
  // get all kukri positions except for movingKukri and killedKukri as they will be rendered in animation components
//   function _placeKukriForPlayer(
//     data: IKukariPositionData,
//     playerNumber: PLAYER_NUMBER,
//     movingKukari: IMovingKukari,
//     killedKukari: IKilledKukari,
//     movableKukaris: number[],
//     isKukariScoreVisible: boolean = false,
//     position: number,
//     index: number
//   ): void {
  
//     if (
//       (playerNumber !== movingKukari?.playerNumber || index != movingKukari?.tokenIndex) &&
//       (playerNumber !== killedKukari?.playerNumber || index != killedKukari?.tokenIndex)
//     )
//       if (position <= data.boardConfig.OUTER_PATH_LENGTH - 2) {
//         const pos = ((data.boardConfig.START_POSITIONS[playerNumber] as number) + position) % data.boardConfig.OUTER_PATH_LENGTH
//         if (!_has(data.commonBoxes, pos)) {
//           data.commonBoxes[pos] = []
//         }
//         data.commonBoxes[pos].push({
//           playerNumber,
//           i: index,
//           score: position,
//           isMovable: playerNumber === PLAYER_NUMBER.ONE && _includes(movableKukaris, index)
//         })
//       } else if (position <= data.boardConfig.PATH_FINAL_INDEX - 1) {
//         if (!_has(data.homeBoxes[playerNumber], position - (data.boardConfig.OUTER_PATH_LENGTH - 1))) {
//           data.homeBoxes[playerNumber][position - (data.boardConfig.OUTER_PATH_LENGTH - 1)] = []
//         }
//         data.homeBoxes[playerNumber][position - (data.boardConfig.OUTER_PATH_LENGTH - 1)].push({
//           i: index,
//           isMovable: playerNumber === PLAYER_NUMBER.ONE && _includes(movableKukaris, index)
//         })
//       } else if (position === data.boardConfig.PATH_FINAL_INDEX) {
//         data.finalBoxes[playerNumber].push(index)
//       }
//   }
  
//   export function getColoredBoxes(state: StateType): IColoredBoxes | null {
//     const kukariMoveConfig = _get(state, 'ludoboard.tableInfo.kukariMoveConfig')
  
//     if (!_isNil(kukariMoveConfig)) {
//       const { initialPosition, playerNumber, currentPosition } = kukariMoveConfig
  
//       return { playerNumber, positions: _range(initialPosition + 1, currentPosition + 1) }
//     }
  
//     return null
//   }
  
//   export function getAllKukariPositions(state: StateType) {
//     const pi = getPlayersInfo(state)
//     const movingKukari = getMovingKukari(state)
//     const killedKukari = getKilledKukari(state)
//     const movableKukaris = getMovableKukaris(state)
//     const isKukariScoreVisible = getIsKukariScoreVisible(state)
  
//     const data: IKukariPositionData = {
//       boardConfig: BOARD_CONFIG[getBoardType(state)] as IBoardConfig,
//       commonBoxes: {},
//       homeBoxes: { [PLAYER_NUMBER.ONE]: {}, [PLAYER_NUMBER.TWO]: {}, [PLAYER_NUMBER.THREE]: {}, [PLAYER_NUMBER.FOUR]: {} },
//       finalBoxes: { [PLAYER_NUMBER.ONE]: [], [PLAYER_NUMBER.TWO]: [], [PLAYER_NUMBER.THREE]: [], [PLAYER_NUMBER.FOUR]: [] }
//     }
  
//     if (!pi) return data
  
//     let si: undefined | number | null = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.TWO}`)
//     !_isNil(si) &&
//       _forEach(
//         pi[si]?.dvp,
//         _placeKukriForPlayer.bind(null, data, PLAYER_NUMBER.TWO, movingKukari, killedKukari, movableKukaris, isKukariScoreVisible)
//       )
  
//     si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.THREE}`)
//     !_isNil(si) &&
//       _forEach(
//         pi[si]?.dvp,
//         _placeKukriForPlayer.bind(null, data, PLAYER_NUMBER.THREE, movingKukari, killedKukari, movableKukaris, isKukariScoreVisible)
//       )
  
//     si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.FOUR}`)
//     !_isNil(si) &&
//       _forEach(
//         pi[si]?.dvp,
//         _placeKukriForPlayer.bind(null, data, PLAYER_NUMBER.FOUR, movingKukari, killedKukari, movableKukaris, isKukariScoreVisible)
//       )
  
//     si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.ONE}`)
//     !_isNil(si) &&
//       _forEach(pi[si]?.dvp, _placeKukriForPlayer.bind(null, data, PLAYER_NUMBER.ONE, movingKukari, killedKukari, movableKukaris, false))
  
//     data.coloredBoxes = getColoredBoxes(state)
  
//     return data
//   }
  
  function getKukarisForPlayerAtPosition(
    position: number,
    si: number,
    startPosition: number,
    outerPathLength: number,
    dvp?: Array<number>
  ) {
    return _reduce(
      dvp,
      (vres, tPos) => {
        if (tPos <= outerPathLength - 2 && (tPos + startPosition) % outerPathLength === position) {
          return vres + 1
        }
        return vres
      },
      0
    )
  }
  
//   export function getKukarisAtPosition(position: number, state: StateType): number {
//     const pi = getPlayersInfo(state)
//     const boardConfig = BOARD_CONFIG[getBoardType(state)] as IBoardConfig
  
//     if (!pi) return 0
  
//     let res = 0
  
//     let si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.ONE}`)
//     if (!_isNil(si)) {
//       res =
//         res +
//         getKukarisForPlayerAtPosition(
//           position,
//           si,
//           boardConfig.START_POSITIONS[PLAYER_NUMBER.ONE] || 0,
//           boardConfig.OUTER_PATH_LENGTH,
//           pi[si]?.dvp
//         )
//     }
  
//     si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.TWO}`)
//     if (!_isNil(si)) {
//       res =
//         res +
//         getKukarisForPlayerAtPosition(
//           position,
//           si,
//           boardConfig.START_POSITIONS[PLAYER_NUMBER.TWO] || 0,
//           boardConfig.OUTER_PATH_LENGTH,
//           pi[si]?.dvp
//         )
//     }
  
//     si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.THREE}`)
//     if (!_isNil(si)) {
//       res =
//         res +
//         getKukarisForPlayerAtPosition(
//           position,
//           si,
//           boardConfig.START_POSITIONS[PLAYER_NUMBER.THREE] || 0,
//           boardConfig.OUTER_PATH_LENGTH,
//           pi[si]?.dvp
//         )
//     }
  
//     si = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.FOUR}`)
//     if (!_isNil(si)) {
//       res =
//         res +
//         getKukarisForPlayerAtPosition(
//           position,
//           si,
//           boardConfig.START_POSITIONS[PLAYER_NUMBER.FOUR] || 0,
//           boardConfig.OUTER_PATH_LENGTH,
//           pi[si]?.dvp
//         )
//     }
  
//     return res
//   }
  
  // export function getKilledKukari(state: StateType) {
  //   return _get(state, 'ludoboard.tableInfo.killedKukari', null)
  // }
  
  export function getFinalMovePlayers(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.finalMovePlayers', [])
  }
  
  export function getLeftPlayers(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.leftPlayers', [])
  }
  
  // export function getTst(state: StateType): string | null {
  //   return _get(state, 'ludoboard.tableInfo.tst', null) as string | null
  // }
  
//   export function getUserProfileById(zuid: number, state: StateType): UserProfile {
//     return _get(state, `ludoboard.userProfile.${zuid}`)
//   }
  
  // export function isVoiceOverEnabled(state: StateType) {
  //   return _get(state, `ludoboard.tableInfo.ftcpData.isVoiceOverEnabled`)
  // }
  
  // export function getTimeLimitInSeconds(state: StateType) {
  //   return _get(state, `ludoboard.tableInfo.timeLimitInSecs`, 0) as number
  // }
  
//   export function getDiceNudge(state: StateType): string {
//     const _diceNudge = _get(state, 'ludoboard.tableInfo.ftcpData.diceNudge', null)
//     const _turnCount = getCurrentPlayerTurnCount(state)
//     if (!_isNil(_diceNudge) && !_isNil(_turnCount) && _diceNudge?.maxNudgeCount > _turnCount) {
//       return _diceNudge?.text
//     }
//     return ''
//   }
  
//   export function getTokenNudge(state: StateType): string {
//     const _tokenNudge = _get(state, 'ludoboard.tableInfo.ftcpData.tokenNudge', null)
//     const _turnCount = getCurrentPlayerTurnCount(state)
//     if (!_isNil(_tokenNudge) && !_isNil(_turnCount) && _tokenNudge.maxNudgeCount > _turnCount) {
//       return _tokenNudge.text
//     }
//     return ''
//   }
  
//   export function getFirstGameTimerNudge(state: StateType): IGameTimerNudgeStore | null {
//     return _get(state, 'ludoboard.tableInfo.ftcpData.firstGameTimerNudge', null)
//   }
//   export function getLastGameTimerNudge(state: StateType): IGameTimerNudgeStore | null {
//     return _get(state, 'ludoboard.tableInfo.ftcpData.lastGameTimerNudge', null)
//   }
  export function getTakeHomeNudge(state: StateType): {
    showAfterPosition: number
    showFor: number
  } | null {
    return _get(state, 'ludoboard.tableInfo.ftcpData.takeHomeNudge', null)
  }
  export function getShowTakeHomeNudge(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.showTakeHomeNudge', false)
  }
  // export function getCurrentPlayerTurnCount(state: StateType): number {
  //   return _get(state, 'ludoboard.tableInfo.currentPlayerTurnCount', 0)
  // }
  
  // export function getMaxCurrentUserTurnAnimation(state: StateType): number {
  //   return _get(state, 'ludoboard.tableInfo.ftcpData.maxCurrentUserTurnAnimation', 0)
  // }
  
  // export function getMaxOtherUserTurnAnimation(state: StateType): number {
  //   return _get(state, 'ludoboard.tableInfo.ftcpData.maxOtherUserTurnAnimation', 0)
  // }
  
  // export function getShouldShowScoreAnimation(playerNumber: PLAYER_NUMBER, state: StateType): boolean {
  //   const _turnCount = getCurrentPlayerTurnCount(state)
  //   const maxUserTurnAnimation =
  //     playerNumber === PLAYER_NUMBER.ONE ? getMaxCurrentUserTurnAnimation(state) : getMaxOtherUserTurnAnimation(state)
  
  //   return (
  //     !_isNil(playerNumber) && !_isNil(_turnCount) && maxUserTurnAnimation > 0 && _turnCount < getMaxOtherUserTurnAnimation(state)
  //   )
  // }
  
//   export function getScoreFlyAnimationConfig(
//     playerNumber: PLAYER_NUMBER,
//     state: StateType
//   ): IScoreFlyAnimationConfigForPlayer | null {
//     return _get(state, `ludoboard.tableInfo.scoreFlyAnimationConfig[${playerNumber}]`, null)
//   }
  
  export function getRoundNumber(state: StateType): number | null {
    return _get(state, 'ludoboard.tableInfo.roundNumber', null)
  }
  
  export function getGameTimeLimitText(state: StateType): string | null {
    return getShowGameTimeNudge(state) ? _get(state, 'ludoboard.tableInfo.gameTimeLimitText', null) : null
  }
  
//   export function getTtoScreenData(state: StateType): ITtoScreenData | null {
//     return _get(state, 'ludoboard.tableInfo.ttoScreenData', null)
//   }
  
//   export function getLocationTooltipText(state: StateType): string | null {
//     const coinAnimation = getCoinAnimation(state)
//     const totalPlayers = getTotalPlayers(state)
//     if (totalPlayers !== 2 || !coinAnimation) {
//       return null
//     }
//     const seatIndex = _get(state, `ludoboard.tableInfo.${PLAYER_NUMBER.THREE}`)
//     return _get(state, `ludoboard.tableInfo.pi[${seatIndex}].messages.${translations.getLanguage()}.userCurrStateText`, null)
//   }
  
//   export function getSkipCountForNudge(state: StateType): TTO_COUNT | null {
//     return _get(state, 'ludoboard.tableInfo.skipCountForNudge', null)
//   }
  
//   export function getTokenCutCN(state: StateType): IContextualNudgeItemInStore {
//     const movableKukaris = getMovableKukaris(state)
  
//     if (_isEmpty(movableKukaris)) {
//       return []
//     }
  
//     return _get(state, 'ludoboard.tableInfo.tokenCutCN', [])
//   }
  
//   export function getReachHomeCN(state: StateType): IContextualNudgeItemInStore {
//     const movableKukaris = getMovableKukaris(state)
  
//     if (_isEmpty(movableKukaris)) {
//       return []
//     }
  
//     return _get(state, 'ludoboard.tableInfo.reachHomeCN', [])
//   }
  
//   export function getSafeCN(state: StateType): IContextualNudgeItemInStore {
//     const movableKukaris = getMovableKukaris(state)
  
//     if (_isEmpty(movableKukaris)) {
//       return []
//     }
  
//     return _get(state, 'ludoboard.tableInfo.safeCN', [])
//   }
  
//   export function getContextualNudges(state: StateType): { [key in CONTEXTUAL_NUDGE_TYPE]: IContextualNudgeItemInStore } {
//     return {
//       [CONTEXTUAL_NUDGE_TYPE.TOKEN_CUT]: getTokenCutCN(state),
//       [CONTEXTUAL_NUDGE_TYPE.REACH_HOME]: getReachHomeCN(state),
//       [CONTEXTUAL_NUDGE_TYPE.SAFE]: getSafeCN(state)
//     }
//   }
  
  export function getIsPrizepoolTooltipVisible(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.isPrizepoolTooltipVisible', false)
  }
  
  export function getIsTNCBSVisible(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.isTNCBSVisible', false)
  }
  
//   export function getTotalTimeBankTime(state: StateType): number {
//     return _get(state, 'ludoboard.tableInfo.totalTimeBankTime')
//   }
  
  export function getLtid(state: StateType): number | null {
    return _get(state, 'ludoboard.tableInfo.ltid', null)
  }
  
//   export function getIsScoreRevealAnimationVisible(state: StateType): boolean {
//     return _get(state, 'ludoboard.tableInfo.isScoreRevealAnimationVisible')
//   }
  
//   export function getQuickGuide(state: StateType): Array<IQuickGuideItem> {
//     return _get(state, 'ludoboard.tableInfo.quickGuide')
//   }
  
  export function getMaxWinners(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.maxWinners', null)
  }
  
  export function getTextForGameFeed(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.textForGameFeed', null)
  }
  
  export function getTurnCount(state: StateType) {
    return _get(state, 'ludoboard.tableInfo.turnCount', null)
  }
//   export function getIsSkipTooltipVisible(state: StateType): boolean {
//     return _get(state, 'ludoboard.tableInfo.isSkipTooltipVisible')
//   }
//   export function getNxUserInfoData(state: StateType): object {
//     return _get(state, 'ludoboard.tableInfo.pgi')
//   }
  export function getExtraPointForHomeEnabled(state: StateType): boolean {
    return _get(state, 'ludoboard.tableInfo.extraPointForHomeEnabled', false)
  }
  